export default __webpack_public_path__ + "52987c34335845f4da5e2695351e7134.svg";